import ModalViewModel from 'infra/ModalViewModel'
import { action, computed, makeObservable, observable } from 'mobx'

export class FileNameMismatchViewModel extends ModalViewModel {
  @observable
  clientNames: { firstName: string; lastName: string }[] = []

  @observable
  files: File[] = []

  constructor() {
    super()
    makeObservable(this)

    this.close$.subscribe(this.reset)
  }

  @computed
  get clientNamesList() {
    return this.clientNames
      .map((client) => `${client.firstName} ${client.lastName}`)
      .join(', ')
  }

  @computed
  get filesList() {
    return this.files.map((file) => file.name)
  }

  @computed
  get fileCount() {
    return this.files.length
  }

  @computed
  get clientCount() {
    return this.clientNames.length
  }

  @action.bound
  setClientNames(clientNames: { firstName: string; lastName: string }[]) {
    this.clientNames = clientNames
  }

  @action.bound
  setFiles(files: File[]) {
    this.files = files
  }

  @action.bound
  reset() {
    this.clientNames = []
    this.files = []
  }

  @action
  open(clientNames: { firstName: string; lastName: string }[], files: File[]) {
    this.setClientNames(clientNames)
    this.setFiles(files)
    this.show()
  }
}
